<script setup lang="ts">
import type { ButtonType } from "@lxc/app-device-common";
import ILxcPlusCircle from "~icons/lxc/plus-circle";

const props = defineProps<{
  buttonType: ButtonType;
  text: string;
  class?: string | string[];
  disabled?: boolean;
}>();

defineEmits(["click"]);

const buttonClass = computed(() => {
  const buttonClasses = [
    "rounded-lg",
    "!px-4",
    "!py-4",
    "w-full",
    "gap-2",
    "!justify-start",
    "!bg-transparent",
    "!text-sm",
  ];

  const propsClass: string[] | undefined = Array.isArray(props.class)
    ? props.class
    : props.class?.split(" ");
  return buttonClasses.concat(propsClass ?? []);
});
</script>

<template>
  <lxc-button
    :title="text"
    :type="buttonType"
    :text="text"
    :class="buttonClass"
    :icon="ILxcPlusCircle"
    :icon-class="['w-6', 'h-6']"
    :disabled="disabled"
    @click="$emit('click')"
  />
</template>
